/**
 * @generated SignedSource<<cf7c819a3c3836eecfceb5bb647b2fa2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignSeriesBreadcrumbs_iconicDesignSeriesPage$data = {
  readonly cmsTopModule: {
    readonly title: string | null;
  } | null;
  readonly " $fragmentType": "DesignSeriesBreadcrumbs_iconicDesignSeriesPage";
};
export type DesignSeriesBreadcrumbs_iconicDesignSeriesPage$key = {
  readonly " $data"?: DesignSeriesBreadcrumbs_iconicDesignSeriesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignSeriesBreadcrumbs_iconicDesignSeriesPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignSeriesBreadcrumbs_iconicDesignSeriesPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesignSeriesCmsTopModule",
      "kind": "LinkedField",
      "name": "cmsTopModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IconicDesignSeriesPage",
  "abstractKey": null
};

(node as any).hash = "90e6e94bd8cb00e10f82c58dede362af";

export default node;
